/**
 * Wrapper for QuickCreateMenu that navigates to the document import page.
 * Previously opened AccountingDocumentUpload dialog; now uses the unified import flow.
 */

import { useEffect } from 'react';
import { useGuardedNavigate } from '../../shared/hooks/useGuardedNavigate';

interface QuickCreateDocumentUploadFormProps {
  open: boolean;
  onClose: () => void;
}

export function QuickCreateDocumentUploadForm({ open, onClose }: QuickCreateDocumentUploadFormProps) {
  // Not a form at all — a shim for the "+ → Document upload" menu entry, which
  // sends the user to a PAGE rather than creating anything. That is the same
  // gesture as QuickCreateMenu's NAVIGATION_BASED_ENTITIES, so it is guarded the
  // same way; the exempt QuickCreate shape is a hop to a record just CREATED,
  // which this is not.
  const navigate = useGuardedNavigate();

  useEffect(() => {
    if (open) {
      navigate('/accounting/import-bills/new');
      onClose();
    }
  }, [open, navigate, onClose]);

  return null;
}
